import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetClasses(page: number, size: number, filters?: any) {
  return useQuery(
    [URL.CLASSES_OPERACAO.OBTER, filters, page, size],
    async () => {
      const { data, headers } = await http.get<any, any>(URL.CLASSES_OPERACAO.OBTER, {
        params: {
          ...filters,
          page,
          size,
        },
      });
      return { data, paginate: JSON.parse(headers.paginate) };
    },
    {
      keepPreviousData: true,
    }
  );
}

export default useGetClasses;
